module.exports = __webpack_public_path__ + "img/zoom4.dae95336.svg";